import { api } from "./api";
import { GET_NOTIFICATIONS, MARK_NOTIFICATIONS } from "../apiEndPoints";

export const notificationApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: ({ student_id }) => {
        let URL = `${GET_NOTIFICATIONS}/${student_id}`;
        return {
          url: URL,
          method: "GET",
        };
      },
    }),
    markNotifications: builder.mutation({
      query: (payload) => ({
        url: MARK_NOTIFICATIONS,
        method: "PUT",
        body: payload,
      }),
    }),
  }),
});

export const { useGetNotificationsQuery, useMarkNotificationsMutation } =
  notificationApiSlice;
